<template>
  <h3>Quiz vragen</h3>
  <div class="questions-container" v-if="questions">
    <div class="question" :key="question.id" v-for="(question, index) in questions">
      <h5 class="question-index-title">Vraag {{ index + 1 }}</h5>
      <div class="row">
        <div class="col-12 col-md-6">
          <p class="question-phrase">
            {{ question.phrase }}
          </p>
          <ul class="possible-answers">
            <li :key="index" v-for="(answer, index) in question.possibleAnswers">
              <template v-if="index === question.correctAnswerIndex">
                <b>{{ answer }} (correct)</b>
              </template>
              <template v-else>
                {{ answer }}
              </template>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-6">
          <div class="quest-media-item" v-if="question.mediaItem?.type !== mediaItemTypeEnum.none && question.mediaItem?.imageAsset">
            <template v-if="question.mediaItem?.type === mediaItemTypeEnum.image && question.mediaItem?.imageAsset">
              <div class="question-image">
                <img class="img-fluid" :src="question.mediaItem.imageAsset.url" :alt="'Afbeelding vraag ' + (index + 1)"/>
              </div>
            </template>
            <template v-else-if="question.mediaItem?.type === mediaItemTypeEnum.video && question.mediaItem?.videoUrl">
              <div class="embed-responsive embed-responsive-16by9 video-preview">
                <iframe class="embed-responsive-item" :src="convertYoutubeUrlToEmbedUrl(question.mediaItem?.videoUrl)"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QuestMediaTypeEnum } from "sandpiper_api";
import YoutubeVideoEmbedder from "@/mixins/YoutubeVideoEmbedder";

export default {
  name: "QuestQuizDetails",
  mixins: [ YoutubeVideoEmbedder ],
  props: {
    questions: Array
  },
  data()
  {
    return {
      mediaItemTypeEnum: new QuestMediaTypeEnum()
    }
  }
}
</script>

<style lang="scss" scoped>
h3
{
  font-size: 20px;
}

.question-index-title
{
  font-size: 16px;
  color: $primary-blue;
}

.question-phrase
{
  margin: 10px 0 5px;
}

.possible-answers
{
  list-style-position: inside;
  padding: 0;
}
</style>